module.exports = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 464.8 515.6'%3E%3Cpath fill='%238ED6FB' d='M450.5 397.3L241.6 515.6v-92l130.2-71.7 78.7 45.4zm14.3-12.9V137.2l-76.4 44.1v159l76.4 44.1zM14.3 397.3l208.9 118.2v-92L93 351.9l-78.7 45.4zM0 384.4V137.2l76.4 44.1v159L0 384.4zm8.9-263.2L223.2 0v89L85.9 164.5l-1.1.6-75.9-43.9zm446.9 0L241.6 0v89l137.2 75.6 1.1.6 75.9-44z'/%3E%3Cpath fill='%231C78C0' d='M223.2 402.6L94.8 331.9V192l128.4 74.1v136.5zm18.4 0L370 332V192l-128.4 74.1v136.5zM103.4 175.8l129-70.9 128.9 70.9-128.9 74.4-129-74.4z'/%3E%3C/svg%3E"


//////////////////
// WEBPACK FOOTER
// ./assets/img/tools/webpack.svg
// module id = 72
// module chunks = 0